import React from 'react';
import { Box, Card, TextField, MenuItem, Typography, Chip } from '@mui/material';
import Grid from '@mui/material/Grid';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Chart from 'react-apexcharts';

import OverviewTotalSales from './components/biReports/OverviewTotalSales';
import OverviewMonthSales from './components/biReports/OverviewMonthSales';
import OverviewMonthCustomers from './components/biReports/OverviewMonthCustomers';
import OverviewTotalCustomers from './components/biReports/OverviewTotalCustomers';

import SalesTopList from './components/biReports/SalesTopList';
import SalesLastOrders from './components/biReports/SalesLastOrders';
import SalesCountOrders from './components/biReports/SalesCountOrders';
import SalesPVMGrossPage from 'components/biReports/SalesPVMGrossPage';
import InventoryPVMAnalysisPage from 'components/biReports/InventoryPVMAnalysisPage';
import SalesPeriodLocationList from './components/biReports/SalesPeriodLocationList';
import SalesTransPeriodLocationList from './components/biReports/SalesTransPeriodLocationList';
import OverviewPosOffline from './components/biReports/OverviewPosOffline';
import SalesExport from './components/biReports/SalesExport';
import IntelligenceInsights from './components/biReports/IntelligenceInsights';

import Client from './components/Client';
import Config from './components/ClientConfig';
import BackofficeReportsApi from './components/biReports/backofficeReportsApi';

import PeopleIcon from '@mui/icons-material/People';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';

import { format } from 'date-fns';

let d = new Date();
let today = format(d, 'yyyy-MM-dd');

class Stats extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			client: new Client("none"),
			edit: false,
			date: today,
			validDate: today,
			tabValue: "value",
			tab2Value: "intel",
			platform: 0,
			platforms: [
				{ iref: 0, name: "All" },
				{ iref: 3, name: "Glovo" },
				{ iref: 4, name: "Wolt" },
				{ iref: 5, name: "Bolt" }
			],
			locationGroups: [],
			locations: [],
			selectedLocationGroup: "all",
			dailyKpis: null,
		};

		this.handleTabChange = this.handleTabChange.bind(this);
		this.handleTab2Change = this.handleTab2Change.bind(this);
		this.selectPlatform = this.selectPlatform.bind(this);
		this.loadDailyKpis = this.loadDailyKpis.bind(this);
	}

	componentDidMount() {
		const lg = BackofficeReportsApi.getLocationGroups(this.state.client) || [];

		const loc = this.state.client.getData(
			Config.API_URL_LOCATIONS + 'list_locations/',
			{ status: 1 }
		) || {};

		const locationGroups = Array.isArray(lg.locationsGroups)
			? lg.locationsGroups
			: Array.isArray(lg)
				? lg
				: [];

		const locations = Array.isArray(loc.locations)
			? loc.locations
			: Array.isArray(loc)
				? loc
				: [];

		this.setState({ locationGroups, locations }, () => {
			this.loadDailyKpis();

			if (this.props.onReady) {
				this.props.onReady();
			}
		});
	}

	componentWillUnmount() {
	}

	isValidDateValue = (value) => {
		if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) {
			return false;
		}
		const year = Number(value.substring(0, 4));
		// Adjust range if needed
		if (year < 2000 || year > 2100) {
			return false;
		}
		const parsedDate = new Date(`${value}T00:00:00`);
		if (Number.isNaN(parsedDate.getTime())) {
			return false;
		}
		const normalizedDate = [
			parsedDate.getFullYear(),
			String(parsedDate.getMonth() + 1).padStart(2, '0'),
			String(parsedDate.getDate()).padStart(2, '0'),
		].join('-');
		return normalizedDate === value;
	}

	addDate = (event) => {
		if (!event || !event.target) {
			return;
		}
		const value = event.target.value;
		this.setState(
			{ date: value },
			() => {
				if (this.isValidDateValue(value)) {
					this.setState(
						{ validDate: value },
						() => this.loadDailyKpis()
					);
				}
			}
		);
	}

	handleTabChange(event, newValue) {
		this.setState({ tabValue: newValue });
	}

	handleTab2Change(event, newValue) {
		this.setState({ tab2Value: newValue });
	}

	selectPlatform = (event) => {
		this.setState({ platform: event.target.value });
	}

	loadDailyKpis() {
		if (!this.isValidDateValue(this.state.validDate)) {
			return;
		}
		const result = BackofficeReportsApi.getSalesDailyKpi(
			this.state.client,
			{
				date: this.state.validDate,
				location: 0,
			}
		) || null;

		this.setState({ dailyKpis: result });
	}

	formatCompactNumber(value) {
		const number = Number(value || 0);

		if (Math.abs(number) >= 1000000) {
			return `${(number / 1000000).toFixed(1)}M`;
		}

		if (Math.abs(number) >= 1000) {
			return `${(number / 1000).toFixed(1)}K`;
		}

		return number.toFixed(0);
	}

	formatPercent(value) {
		if (value === null || value === undefined || Number.isNaN(Number(value))) {
			return 'n/a';
		}

		const number = Number(value);
		const sign = number > 0 ? '+' : '';

		return `${sign}${number.toFixed(1)}%`;
	}

	getDeltaSx(value) {
		if (value === null || value === undefined || Number.isNaN(Number(value))) {
			return {
				bgcolor: 'rgba(100, 116, 139, 0.12)',
				color: '#475569',
				borderColor: 'rgba(100, 116, 139, 0.20)',
			};
		}

		if (Number(value) >= 0) {
			return {
				bgcolor: 'rgba(46, 125, 50, 0.12)',
				color: '#2e7d32',
				borderColor: 'rgba(46, 125, 50, 0.22)',
			};
		}

		return {
			bgcolor: 'rgba(211, 47, 47, 0.12)',
			color: '#d32f2f',
			borderColor: 'rgba(211, 47, 47, 0.22)',
		};
	}

	renderMiniMetric(label, value, subtitle, deltaValue = null) {
		const showDelta = deltaValue !== null && deltaValue !== undefined;

		return (
			<Box
				sx={{
					height: '100%',
					minHeight: 0,
					p: { xs: 0.75, sm: 0.85, md: 0.9 },
					borderRadius: '14px',
					bgcolor: '#fff',
					border: '1px solid rgba(226, 232, 240, 0.95)',
					boxShadow: '0 3px 10px rgba(15, 23, 42, 0.04)',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					textAlign: 'center',
					boxSizing: 'border-box',
					overflow: 'hidden',
				}}
			>
				<Typography
					sx={{
						fontSize: { xs: 10, sm: 10.5, md: 10.5 },
						fontWeight: 900,
						letterSpacing: '0.045em',
						textTransform: 'uppercase',
						color: '#1a237e',
						lineHeight: 1.1,
						mb: 0.15,
						whiteSpace: 'nowrap',
						maxWidth: '100%',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
					}}
				>
					{label}
				</Typography>

				<Box
					sx={{
						mt: 0.35,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: 0.5,
						minWidth: 0,
						maxWidth: '100%',
					}}
				>
					<Typography
						sx={{
							fontSize: { xs: 22, sm: 24, md: 23 },
							fontWeight: 900,
							lineHeight: 1,
							color: '#111827',
							whiteSpace: 'nowrap',
							minWidth: 0,
							overflow: 'hidden',
							textOverflow: 'ellipsis',
						}}
					>
						{value}
					</Typography>

					{showDelta ? (
						<Chip
							size="small"
							label={this.formatPercent(deltaValue)}
							sx={{
								height: 21,
								fontWeight: 900,
								fontSize: 10.5,
								border: '1px solid',
								flexShrink: 0,
								...this.getDeltaSx(deltaValue),
								'& .MuiChip-label': { px: 0.6 },
							}}
						/>
					) : null}
				</Box>

				<Typography
					sx={{
						mt: 0.4,
						fontSize: { xs: 10.5, sm: 11 },
						color: '#64748b',
						fontWeight: 800,
						lineHeight: 1.15,
						whiteSpace: 'nowrap',
						maxWidth: '100%',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
					}}
				>
					{subtitle}
				</Typography>
			</Box>
		);
	}

	renderChartLegendItem(label, value, color, active = false) {
		return (
			<Box
				key={label}
				sx={{
					minWidth: 0,
					textAlign: 'center',
				}}
			>
				<Box
					sx={{
						width: 8,
						height: 8,
						borderRadius: '50%',
						bgcolor: color,
						mx: 'auto',
						mb: 0.35,
					}}
				/>

				<Typography
					sx={{
						fontSize: 10.5,
						fontWeight: 900,
						color: active ? '#1a237e' : '#64748b',
						lineHeight: 1.1,
					}}
				>
					{label}
				</Typography>

				<Typography
					sx={{
						mt: 0.2,
						fontSize: 11,
						fontWeight: 900,
						color: '#111827',
						lineHeight: 1.1,
					}}
				>
					{value}
				</Typography>
			</Box>
		);
	}

	renderSalesPulsePanel(data, completedSales, completedOrders, completedAov, dailyPanelHeight, dailyPanelMinHeight) {
		const pulse = data.sales_pulse || {};
		const isTodayLive = data.comparison_mode === 'today_live';

		const actualSales = pulse.actual_sales !== undefined && pulse.actual_sales !== null
			? pulse.actual_sales
			: completedSales;

		const expectedSales = pulse.expected_sales;
		const gapValue = pulse.gap_value;
		const gapPercent = pulse.gap_percent;
		const achievementPercent = pulse.achievement_percent;

		const hasExpected = expectedSales !== null
			&& expectedSales !== undefined
			&& !Number.isNaN(Number(expectedSales))
			&& Number(expectedSales) > 0;

		const progressPercent = hasExpected && achievementPercent !== null && achievementPercent !== undefined
			? Math.max(0, Math.min(100, Number(achievementPercent)))
			: 0;

		const gapColor = gapPercent === null || gapPercent === undefined
			? '#64748b'
			: Number(gapPercent) >= 0
				? '#2e7d32'
				: '#d32f2f';

		const gapBg = gapPercent === null || gapPercent === undefined
			? 'rgba(100, 116, 139, 0.12)'
			: Number(gapPercent) >= 0
				? 'rgba(46, 125, 50, 0.12)'
				: 'rgba(211, 47, 47, 0.12)';

		const pulseTitle = isTodayLive
			? 'Live sales pulse'
			: 'Sales pulse';

		const defaultStatusLabel = !hasExpected
			? 'No expected baseline'
			: Number(gapPercent || 0) >= 10
				? (isTodayLive ? 'Ahead of pace' : 'Above expected')
				: Number(gapPercent || 0) <= -10
					? (isTodayLive ? 'Behind pace' : 'Below expected')
					: (isTodayLive ? 'On pace' : 'Near expected');

		const statusLabel = isTodayLive
			? defaultStatusLabel
			: (pulse.status_label || defaultStatusLabel);
		const isBehindPace = isTodayLive && statusLabel === 'Behind pace';
		const statusColor = isBehindPace
			? '#1a237e'
			: gapColor;
		const statusBg = isBehindPace
			? 'rgba(26, 35, 126, 0.08)'
			: gapBg;
		const statusBorderColor = isBehindPace
			? 'rgba(26, 35, 126, 0.18)'
			: gapColor === '#64748b'
				? 'rgba(100, 116, 139, 0.22)'
				: gapColor === '#2e7d32'
					? 'rgba(46, 125, 50, 0.22)'
					: 'rgba(211, 47, 47, 0.22)';
		
		const explanation = pulse.expected_explanation_short || 'Expected sales baseline';
		const confidenceLabel = pulse.expected_confidence_label || 'Confidence n/a';

		const baseLabel = pulse.expected_base_value !== undefined
			&& pulse.expected_base_value !== null
			&& !Number.isNaN(Number(pulse.expected_base_value))
			? `LY: ${this.formatCompactNumber(pulse.expected_base_value)}`
			: pulse.expected_base_label || 'Expected';

		const trendLabel = pulse.expected_trend_factor !== undefined
			&& pulse.expected_trend_factor !== null
			&& !Number.isNaN(Number(pulse.expected_trend_factor))
			? `Trend ${this.formatPercent((Number(pulse.expected_trend_factor) - 1) * 100)}`
			: 'Trend';

		const contextLabel = pulse.expected_monthly_context_factor !== undefined
			&& pulse.expected_monthly_context_factor !== null
			&& !Number.isNaN(Number(pulse.expected_monthly_context_factor))
			&& Number(pulse.expected_monthly_context_factor) !== 1
			? `Context ${this.formatPercent((Number(pulse.expected_monthly_context_factor) - 1) * 100)}`
			: confidenceLabel;

		const gapPercentLabel = isTodayLive
			? 'vs expected pace'
			: 'vs expected';

		const explanationChipSx = {
			height: { lg: 30, xl: 32 },
			minWidth: 0,
			maxWidth: '100%',
			fontWeight: 900,
			fontSize: { lg: 11.5, xl: 11.5 },
			border: '1px solid',
			justifyContent: 'center',
			borderRadius: 999,
			bgcolor: 'rgba(100, 116, 139, 0.08)',
			color: '#475569',
			borderColor: 'rgba(100, 116, 139, 0.14)',
			'& .MuiChip-label': {
				px: { lg: 1, xl: 1.1 },
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
			},
		};

		return (
			<Box
				sx={{
					width: '100%',
					height: dailyPanelHeight,
					minHeight: dailyPanelMinHeight,
					p: { xs: 1.05, sm: 1.15, md: 1.2 },
					borderRadius: '16px',
					bgcolor: '#fff',
					border: '1px solid rgba(226, 232, 240, 0.95)',
					boxShadow: '0 3px 10px rgba(15, 23, 42, 0.04)',
					boxSizing: 'border-box',
					overflow: 'hidden',
					display: 'grid',
					gridTemplateColumns: {
						xs: '1fr',
						xl: 'minmax(0, 70%) minmax(240px, 30%)',
					},
					gap: {
						xs: 0,
						lg: 0.85,
						xl: 1.55,
					},
					alignItems: 'stretch',
				}}
			>
				<Box
					sx={{
						minWidth: 0,
						display: 'flex',
						flexDirection: 'column',
						justifyContent: {
							xs: 'flex-start',
							xl: 'space-between',
						},
						gap: { xs: 0.65, md: 0.7 },
					}}
				>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							gap: 1,
							minWidth: 0,
						}}
					>
						<Typography
							sx={{
								fontSize: { xs: 11.5, sm: 12, xl: 11.5 },
								fontWeight: 900,
								letterSpacing: '0.05em',
								textTransform: 'uppercase',
								color: '#1a237e',
								whiteSpace: 'nowrap',
							}}
						>
							{pulseTitle}
						</Typography>

						<Chip
							size="small"
							label={statusLabel}
							sx={{
								height: { xs: 25, xl: 28 },
								fontWeight: 900,
								fontSize: { xs: 11, xl: 12 },
								border: '1px solid',
								borderColor: statusBorderColor,
								bgcolor: statusBg,
								color: statusColor,
								maxWidth: { xs: '52%', xl: '46%' },
								flexShrink: 0,
								'& .MuiChip-label': {
									px: { xs: 0.9, xl: 1.1 },
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								},
							}}
						/>
					</Box>

					<Box
						sx={{
							display: 'grid',
							gridTemplateColumns: '1fr 1fr',
							columnGap: { xs: 1.5, md: 2 },
							alignItems: 'end',
						}}
					>
						<Box sx={{ minWidth: 0 }}>
							<Typography
								sx={{
									fontSize: { xs: 10.5, md: 11.5, xl: 12 },
									fontWeight: 900,
									textTransform: 'uppercase',
									letterSpacing: '0.04em',
									color: '#64748b',
									lineHeight: 1.1,
								}}
							>
								Actual
							</Typography>

							<Typography
								sx={{
									mt: 0.2,
									fontSize: { xs: 28, sm: 30, md: 32, xl: 32 },
									fontWeight: 900,
									lineHeight: 1,
									color: '#111827',
									whiteSpace: 'nowrap',
								}}
							>
								{this.formatCompactNumber(actualSales)}
							</Typography>
						</Box>

						<Box sx={{ minWidth: 0, textAlign: 'right' }}>
							<Typography
								sx={{
									fontSize: { xs: 10.5, md: 11.5, xl: 12 },
									fontWeight: 900,
									textTransform: 'uppercase',
									letterSpacing: '0.04em',
									color: '#64748b',
									lineHeight: 1.1,
								}}
							>
								Expected
							</Typography>

							<Typography
								sx={{
									mt: 0.2,
									fontSize: { xs: 28, sm: 30, md: 32, xl: 32 },
									fontWeight: 900,
									lineHeight: 1,
									color: '#111827',
									whiteSpace: 'nowrap',
								}}
							>
								{hasExpected ? this.formatCompactNumber(expectedSales) : 'n/a'}
							</Typography>
						</Box>
					</Box>

					<Box>
						<Box
							sx={{
								height: { xs: 9, xl: 10 },
								width: '100%',
								borderRadius: 999,
								bgcolor: 'rgba(100, 116, 139, 0.13)',
								overflow: 'hidden',
							}}
						>
							<Box
								sx={{
									height: '100%',
									width: `${progressPercent}%`,
									borderRadius: 999,
									bgcolor: statusColor,
									transition: 'width 250ms ease',
								}}
							/>
						</Box>

						<Box
							sx={{
								mt: 0.55,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-between',
								gap: 1,
								minWidth: 0,
							}}
						>
							<Typography
								sx={{
									fontSize: { xs: 12, md: 12.5, xl: 12.5 },
									fontWeight: 900,
									color: statusColor,
									whiteSpace: 'nowrap',
								}}
							>
								{hasExpected
									? `${this.formatCompactNumber(gapValue)} gap`
									: 'Expected unavailable'}
							</Typography>

							<Typography
								sx={{
									fontSize: { xs: 12, md: 12.5, xl: 12.5 },
									fontWeight: 900,
									color: statusColor,
									whiteSpace: 'nowrap',
								}}
							>
								{hasExpected ? `${this.formatPercent(gapPercent)} ${gapPercentLabel}` : ''}
							</Typography>
						</Box>
					</Box>

					<Typography
						sx={{
							fontSize: { xs: 11.5, md: 12, xl: 12 },
							color: '#64748b',
							fontWeight: 800,
							lineHeight: 1.15,
							textAlign: 'left',
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							minWidth: 0,
						}}
					>
						Expected: {explanation}
					</Typography>
				</Box>

				<Box
					sx={{
						minWidth: 0,
						display: {
							xs: 'none',
							lg: 'grid',
						},
						gridTemplateColumns: {
							lg: 'repeat(3, minmax(0, 1fr))',
							xl: '1fr',
						},
						gap: {
							lg: 0.75,
							xl: 1,
						},
						alignContent: {
							lg: 'start',
							xl: 'center',
						},
						alignItems: 'center',
						borderTop: {
							lg: '1px solid rgba(226, 232, 240, 0.75)',
							xl: 'none',
						},
						borderLeft: {
							lg: 'none',
							xl: '1px solid rgba(226, 232, 240, 0.9)',
						},
						pl: {
							lg: 0,
							xl: 1.55,
						},
						pt: {
							lg: 0.85,
							xl: 0.1,
						},
					}}
				>
					<Chip
						size="small"
						label={baseLabel}
						sx={{
							...explanationChipSx,
							bgcolor: 'rgba(26, 35, 126, 0.07)',
							color: '#1a237e',
							borderColor: 'rgba(26, 35, 126, 0.14)',
						}}
					/>

					<Chip
						size="small"
						label={trendLabel}
						sx={explanationChipSx}
					/>

					<Chip
						size="small"
						label={contextLabel}
						sx={{
							...explanationChipSx,
							bgcolor: 'rgba(46, 125, 50, 0.10)',
							color: '#2e7d32',
							borderColor: 'rgba(46, 125, 50, 0.16)',
						}}
					/>
				</Box>
			</Box>
		);
	}

	renderDailyKpiRow() {
		const data = this.state.dailyKpis;

		if (!data) {
			return null;
		}

		const selectedDate = data.date || this.state.date;

		const isTodayLive = data.comparison_mode === 'today_live';
		const isYesterdayFallback = data.comparison_mode === 'yesterday_completed';
		const isCompletedDay = data.comparison_mode === 'completed_day';

		const completedBaseDate = data.comparison_base_date || selectedDate;

		const completedSales = data.completed_sales !== undefined
			? data.completed_sales
			: isTodayLive
				? data.sales
				: isYesterdayFallback
					? data.sales_yesterday
					: data.sales;

		const completedOrders = data.completed_orders !== undefined
			? data.completed_orders
			: isTodayLive
				? data.orders
				: isYesterdayFallback
					? data.orders_yesterday
					: data.orders;

		const completedAov = data.completed_aov !== undefined
			? data.completed_aov
			: isTodayLive
				? data.aov
				: isYesterdayFallback
					? data.aov_yesterday
					: data.aov;

		const mainLabel = isTodayLive
			? 'Today'
			: isYesterdayFallback
				? 'Yesterday'
				: 'Day';

		const mainSubtitle = isTodayLive
			? 'Live sales so far'
			: isYesterdayFallback
				? `Completed day: ${completedBaseDate}`
				: selectedDate;

		const chartTitle = isTodayLive ? 'Live context' : 'Sales context';

		const chartSubtitle = isTodayLive
			? 'Today so far / YDay / LW / LY'
			: isYesterdayFallback
				? 'Yesterday / previous / LW / LY'
				: 'Day / previous / LW / LY';

		const chartLabels = isTodayLive
			? ['Today', 'YDay', 'LW', 'LY']
			: isYesterdayFallback
				? ['Yesterday', 'Previous', 'LW', 'LY']
				: ['Day', 'Previous', 'LW', 'LY'];

		const chartColors = ['#1a237e', '#64748b', '#2e7d32', '#d32f2f'];

		const chartValues = [
			Number(completedSales || 0),
			Number(data.sales_yesterday || 0),
			Number(data.sales_last_week || 0),
			Number(data.sales_last_year || 0),
		];

		const chartOptions = {
			chart: {
				type: 'bar',
				toolbar: { show: false },
				sparkline: { enabled: true },
				fontFamily: 'inherit',
			},
			plotOptions: {
				bar: {
					borderRadius: 6,
					columnWidth: '42%',
					distributed: true,
				},
			},
			dataLabels: { enabled: false },
			legend: { show: false },
			grid: { show: false },
			tooltip: {
				y: {
					formatter: (value) => this.formatCompactNumber(value),
				},
			},
			xaxis: {
				categories: chartLabels,
				labels: { show: false },
				axisBorder: { show: false },
				axisTicks: { show: false },
			},
			yaxis: { show: false },
			colors: chartColors,
		};

		const chartSeries = [
			{
				name: 'Sales',
				data: chartValues,
			},
		];

		const dailyPanelHeight = {
			xs: 'auto',
			md: '100%',
		};

		const dailyPanelMinHeight = {
			xs: 156,
			md: 156,
			lg: 194,
			xl: 156,
		};

		return (
			<Grid item xs={12} sx={{ pl: '0 !important' }}>
				<Card
					sx={{
						borderRadius: { xs: '16px', sm: '18px' },
						boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
						bgcolor: 'rgba(248,250,252,0.97)',
						border: '1px solid rgba(226, 232, 240, 0.9)',
						overflow: 'hidden',
						p: { xs: 0.55, sm: 0.65, md: 0.7 },
					}}
				>
					<Grid
						container
						spacing={{ xs: 0.65, md: 0.7 }}
						alignItems="stretch"
						sx={{
							width: '100%',
							m: 0,
						}}
					>
						<Grid item xs={12} md={3} sx={{ pl: '0 !important', display: 'flex' }}>
							<Box
								sx={{
									width: '100%',
									height: dailyPanelHeight,
									minHeight: dailyPanelMinHeight,
									p: { xs: 1.05, sm: 1.15, md: 1.2 },
									borderRadius: '16px',
									bgcolor: '#fff',
									border: '1px solid rgba(226, 232, 240, 0.95)',
									borderTop: '4px solid #1a237e',
									boxShadow: '0 3px 10px rgba(15, 23, 42, 0.04)',
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									justifyContent: 'center',
									textAlign: 'center',
									boxSizing: 'border-box',
								}}
							>
								<Typography
									sx={{
										fontSize: { xs: 11, sm: 11.5 },
										fontWeight: 900,
										letterSpacing: '0.05em',
										textTransform: 'uppercase',
										color: '#1a237e',
									}}
								>
									{mainLabel}
								</Typography>

								<Typography
									sx={{
										mt: 0.35,
										fontSize: { xs: 42, sm: 48, md: 39 },
										fontWeight: 900,
										lineHeight: 0.95,
										color: '#111827',
									}}
								>
									{this.formatCompactNumber(completedSales)}
								</Typography>

								<Box
									sx={{
										mt: { xs: 1.25, md: 1.1 },
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										gap: 0.75,
										flexWrap: 'wrap',
									}}
								>
									<Chip
										size="small"
										label={`${this.formatCompactNumber(completedOrders)} orders`}
										sx={{
											height: 24,
											fontWeight: 800,
											fontSize: 12,
											bgcolor: 'rgba(26, 35, 126, 0.08)',
											color: '#1a237e',
										}}
									/>

									<Chip
										size="small"
										label={`AOV ${Number(completedAov || 0).toFixed(1)}`}
										sx={{
											height: 24,
											fontWeight: 800,
											fontSize: 12,
											bgcolor: 'rgba(100, 116, 139, 0.10)',
											color: '#475569',
										}}
									/>
								</Box>

								<Typography
									sx={{
										mt: 0.55,
										fontSize: { xs: 10.5, sm: 11 },
										color: '#64748b',
										fontWeight: 800,
										lineHeight: 1.1,
										whiteSpace: 'nowrap',
									}}
								>
									{mainSubtitle}
								</Typography>
							</Box>
						</Grid>

						<Grid item xs={12} md={4} sx={{ display: 'flex' }}>
							<Box
								sx={{
									width: '100%',
									height: dailyPanelHeight,
									minHeight: dailyPanelMinHeight,
									p: { xs: 1.05, sm: 1.15, md: 1.2 },
									borderRadius: '16px',
									bgcolor: '#fff',
									border: '1px solid rgba(226, 232, 240, 0.95)',
									boxShadow: '0 3px 10px rgba(15, 23, 42, 0.04)',
									boxSizing: 'border-box',
									overflow: 'hidden',
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
								}}
							>
								<Box
									sx={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										gap: 1,
										mb: 0.25,
									}}
								>
									<Typography
										sx={{
											fontSize: { xs: 11, sm: 11.5 },
											fontWeight: 900,
											letterSpacing: '0.05em',
											textTransform: 'uppercase',
											color: '#1a237e',
										}}
									>
										{chartTitle}
									</Typography>

									<Typography
										sx={{
											fontSize: { xs: 10.5, sm: 11 },
											color: '#64748b',
											fontWeight: 800,
											whiteSpace: 'nowrap',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
										}}
									>
										{chartSubtitle}
									</Typography>
								</Box>

								<Box sx={{ mx: -0.5 }}>
									<Chart
										options={chartOptions}
										series={chartSeries}
										type="bar"
										height={58}
									/>
								</Box>

								<Box
									sx={{
										display: 'grid',
										gridTemplateColumns: 'repeat(4, 1fr)',
										gap: 0.5,
										mt: -0.25,
									}}
								>
									{this.renderChartLegendItem(
										chartLabels[0],
										this.formatCompactNumber(completedSales),
										chartColors[0],
										true
									)}

									{this.renderChartLegendItem(
										chartLabels[1],
										this.formatCompactNumber(data.sales_yesterday),
										chartColors[1]
									)}

									{this.renderChartLegendItem(
										chartLabels[2],
										this.formatCompactNumber(data.sales_last_week),
										chartColors[2]
									)}

									{this.renderChartLegendItem(
										chartLabels[3],
										this.formatCompactNumber(data.sales_last_year),
										chartColors[3]
									)}
								</Box>
							</Box>
						</Grid>

						<Grid item xs={12} md={5} sx={{ display: 'flex' }}>
							{this.renderSalesPulsePanel(
								data,
								completedSales,
								completedOrders,
								completedAov,
								dailyPanelHeight,
								dailyPanelMinHeight
							)}
						</Grid>
					</Grid>
				</Card>
			</Grid>
		);
	}

	render() {
		const platforms = [
			{ iref: 0, name: "All" },
			{ iref: 3, name: "Glovo" },
			{ iref: 4, name: "Wolt" },
			{ iref: 5, name: "Bolt" }
		];

		const fullWidthChildSx = {
			width: '100%',
			minWidth: 0,
			height: '100%',
			display: 'flex',

			'& > *': {
				width: '100% !important',
				maxWidth: '100% !important',
				height: '100% !important',
				minHeight: {
					xs: 128,
					sm: 'auto',
				},
				mx: '0 !important',
				boxSizing: 'border-box',
			},
		};

		return (
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					width: {
						xs: 'calc(100vw - 8px)',
						sm: '100%',
					},
					maxWidth: {
						xs: 'calc(100vw - 8px)',
						sm: '100%',
					},
					ml: {
						xs: 'calc(50% - 50vw + 4px)',
						sm: 0,
					},
					// bgcolor: '#f3f6fa',
					overflowX: 'hidden',
					pt: { xs: 0.75, sm: 1.5, md: 3 },
					pb: { xs: 1, sm: 2, md: 3 },
					px: { xs: 0.5, sm: 1, md: 2 },
					boxSizing: 'border-box',

					'& .MuiGrid-item': {
						minWidth: 0,
					},
					'& .MuiCard-root': {
						maxWidth: '100%',
						boxSizing: 'border-box',
					},
				}}
			>
				<Grid
					container
					spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
					sx={{
						width: '100%',
						maxWidth: '100%',
						m: 0,
					}}
				>
					<Grid item xs={12} sx={{ p: '0 !important' }}>
						<Grid
							container
							spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
							sx={{
								width: '100%',
								m: 0,
							}}
						>
							<Grid item lg={4} md={6} sm={6} xs={6} sx={{ display: 'flex' }}>
								<Box sx={fullWidthChildSx}>
									<OverviewTotalSales />
								</Box>
							</Grid>

							<Grid item lg={4} md={6} sm={6} xs={6} sx={{ display: 'flex' }}>
								<Box sx={fullWidthChildSx}>
									<OverviewTotalCustomers />
								</Box>
							</Grid>

							<Grid item lg={4} md={12} sm={12} xs={12}>
								<Grid
									container
									spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
									sx={{
										width: '100%',
										m: 0,
									}}
								>
									<Grid item sm={6} xs={6} md={6} lg={6}>
										<Box sx={fullWidthChildSx}>
											<OverviewMonthSales />
										</Box>
									</Grid>

									<Grid item sm={6} xs={6} md={6} lg={6}>
										<Box sx={fullWidthChildSx}>
											<OverviewMonthCustomers />
										</Box>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>

					{this.renderDailyKpiRow()}

					<Grid item xs={12} sx={{ pl: '0 !important' }}>
						<Grid
							container
							spacing={1}
							sx={{
								width: '100%',
								m: 0,
							}}
						>
							<Grid item xs={12} lg={6}>
								<Card
									sx={{
										height: { xs: 'auto', md: 640 },
										minHeight: { xs: 610, md: 640 },
										maxHeight: { md: 640 },
										borderRadius: { xs: '14px', sm: '16px' },
										overflow: 'hidden',
										boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',

										// IMPORTANT
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									<Box
										sx={{
											flexShrink: 0,
											px: { xs: 0.75, sm: 1 },
											py: { xs: 0.35, sm: 0.5 },
											borderBottom: '1px solid rgba(0,0,0,0.08)',
											bgcolor: 'rgba(248,250,252,0.95)',
										}}
									>
										<Tabs
											value={this.state.tab2Value}
											onChange={this.handleTab2Change}
											variant="scrollable"
											scrollButtons="auto"
											allowScrollButtonsMobile
											indicatorColor="secondary"
											aria-label="dashboard tabs"
											sx={{
												minHeight: 40,
												overflowX: 'auto',
												'& .MuiTabs-scroller': {
													overflowX: 'auto !important',
												},
												'& .MuiTabs-indicator': {
													height: 3,
													borderRadius: 2,
												},
												'& .MuiTab-root': {
													minHeight: 40,
													textTransform: 'none',
													fontWeight: 700,
													fontSize: { xs: 12.5, sm: 13 },
													px: { xs: 1.15, sm: 1.5 },
												},
											}}
										>
											<Tab label="intel" value="intel" />
											<Tab label="insight" value="countOrder" />
											<Tab label="pvm" value="SalesPVM" />
											<Tab label="margin" value="MarginPVM" />
											<Tab label="last" value="order" />
											<Tab label="top" value="top" />
											<Tab label="off" value="off" />
											<Tab label="export" value="export" />
										</Tabs>
									</Box>

									<Box
										sx={{
											flex: '1 1 auto',
											minHeight: 0,

											// On desktop, do not create a second scroll.
											// Child pages/tables should handle their own internal scroll.
											overflow: { xs: 'auto', lg: 'hidden' },

											display: 'flex',
											flexDirection: 'column',
										}}
									>
										{this.state.tab2Value === "intel" ? (
											<Box
												sx={{
													height: { xs: 'auto', lg: '100%' },
													minHeight: 0,
												}}
											>
												<IntelligenceInsights />
											</Box>
										) : null}

										{this.state.tab2Value === "countOrder" ? (
											<Box
												sx={{
													height: { xs: 'auto', lg: '100%' },
													minHeight: 0,
												}}
											>
												<SalesCountOrders />
											</Box>
										) : null}

										{this.state.tab2Value === "SalesPVM" ? (
											<Box
												sx={{
													height: { xs: 'auto', lg: '100%' },
													minHeight: 0,
												}}
											>
												<SalesPVMGrossPage />
											</Box>
										) : null}

										{this.state.tab2Value === "MarginPVM" ? (
											<Box
												sx={{
													height: { xs: 'auto', lg: '100%' },
													minHeight: 0,
												}}
											>
												<InventoryPVMAnalysisPage />
											</Box>
										) : null}

										{this.state.tab2Value === "order" ? (
											<Box
												sx={{
													height: { xs: 'auto', lg: '100%' },
													minHeight: 0,
												}}
											>
												<SalesLastOrders />
											</Box>
										) : null}

										{this.state.tab2Value === "top" ? (
											<Box
												sx={{
													height: { xs: 'auto', lg: '100%' },
													minHeight: 0,
												}}
											>
												<SalesTopList />
											</Box>
										) : null}

										{this.state.tab2Value === "off" ? (
											<Box
												sx={{
													height: { xs: 'auto', lg: '100%' },
													minHeight: 0,
												}}
											>
												<OverviewPosOffline />
											</Box>
										) : null}

										{this.state.tab2Value === "export" ? (
											<Box
												sx={{
													height: { xs: 'auto', lg: '100%' },
													minHeight: 0,
												}}
											>
												<SalesExport />
											</Box>
										) : null}
									</Box>
								</Card>
							</Grid>

							<Grid item xs={12} lg={6}>
								<Card
									sx={{
										height: { xs: 'auto', lg: '640px' },
										minHeight: { xs: 610, lg: 640 },
										borderRadius: { xs: '14px', sm: '16px' },
										overflow: 'hidden',
										boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
									}}
								>
									<Box
										sx={{
											px: { xs: 1, sm: 1.25 },
											py: { xs: 0.75, sm: 1 },
											borderRadius: '16px',
											display: 'flex',
											flexWrap: 'wrap',
											alignItems: 'center',
											justifyContent: 'flex-start',
											gap: { xs: 0.75, sm: 1 },
											borderBottom: '1px solid rgba(0,0,0,0.08)',
											bgcolor: 'rgba(248,250,252,0.95)',
										}}
									>
										<TextField
											size="small"
											id="date"
											label="date"
											type="date"
											value={this.state.date}
											sx={{
												color: '#e3e3e5',
												width: { xs: 'calc(50% - 4px)', sm: 125 },
												minWidth: 120,
												'& .MuiInputBase-root': {
													height: 38,
													fontSize: { xs: 13, sm: 14 },
													bgcolor: '#fff',
													borderRadius: 1.5,
												},
												'& input': {
													color: '#5b5b5b',
													paddingRight: 0.75,
													paddingLeft: 0.75,
												},
											}}
											InputLabelProps={{
												shrink: true,
												sx: { color: '#5b5b5b' },
											}}
											InputProps={{
												sx: { color: '#5b5b5b' },
											}}
											inputProps={{
												min: '2000-01-01',
												max: '2100-12-31',
											}}
											onChange={this.addDate}
										/>

										<Tabs
											value={this.state.tabValue}
											onChange={this.handleTabChange}
											indicatorColor="secondary"
											sx={{
												width: { xs: 'calc(50% - 4px)', sm: 'auto' },
												minHeight: 38,
												bgcolor: '#fff',
												borderRadius: 1.5,
												border: '1px solid rgba(0,0,0,0.12)',
												'& .MuiTabs-flexContainer': {
													height: 38,
												},
												'& .MuiTabs-indicator': {
													height: 3,
													borderRadius: 2,
												},
												'& .MuiTab-root': {
													minHeight: 38,
													minWidth: { xs: '50%', sm: 42 },
													width: { xs: '50%', sm: 42 },
													maxWidth: { xs: '50%', sm: 42 },
													p: 0,
												},
											}}
										>
											<Tab
												label=""
												value="value"
												icon={<PointOfSaleIcon fontSize="small" />}
												iconPosition="start"
											/>

											<Tab
												label=""
												value="transaction"
												icon={<PeopleIcon fontSize="small" />}
												iconPosition="start"
											/>
										</Tabs>

										<TextField
											select
											size="small"
											variant="standard"
											value={this.state.selectedLocationGroup}
											onChange={(e) =>
												this.setState({ selectedLocationGroup: e.target.value })
											}
											sx={{
												width: { xs: 'calc(50% - 4px)', sm: 180 },
												'& .MuiInputBase-root': {
													height: 38,
													fontSize: { xs: 13, sm: 14 },
												},
											}}
										>
											<MenuItem value="all">All groups</MenuItem>
											{this.state.locationGroups.map((group) => (
												<MenuItem key={group.iref} value={group.iref}>
													{group.name}
												</MenuItem>
											))}
										</TextField>

										<TextField
											id="standard-select-platform"
											size="small"
											select
											value={this.state.platform}
											variant="standard"
											sx={{
												width: { xs: 'calc(50% - 4px)', sm: 100 },
												'& .MuiInputBase-root': {
													height: 38,
													fontSize: { xs: 13, sm: 14 },
												},
											}}
											onChange={this.selectPlatform}
										>
											{platforms.map((option) => (
												<MenuItem key={option.iref} value={option.iref}>
													{option.name}
												</MenuItem>
											))}
										</TextField>
									</Box>

									<Box
										sx={{
											height: { xs: 'auto', lg: 'calc(100% - 57px)' },
											minHeight: { xs: 490, lg: 0 },
											overflow: 'auto',
										}}
									>
										{this.state.tabValue === "value" && (
											<SalesPeriodLocationList
												date={this.state.validDate || this.state.date}
												platform={this.state.platform}
												selectedLocationGroup={this.state.selectedLocationGroup}
												locations={this.state.locations}
											/>
										)}

										{this.state.tabValue === "transaction" && (
											<SalesTransPeriodLocationList
												date={this.state.validDate || this.state.date}
												platform={this.state.platform}
												selectedLocationGroup={this.state.selectedLocationGroup}
												locations={this.state.locations}
											/>
										)}
									</Box>
								</Card>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Box>
		);
	}
}

export default Stats;
